import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import { Auth } from "aws-amplify";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { Container } from "react-bootstrap";
import logo from "../images/AP_wh_txt_logo.png";

export function Header() {
  const { user } = useAuthenticator((context) => [context.user]);

  return (
    <Navbar bg="dark" variant="dark" fixed="top" className="p-0">
      <Container fluid>
        <Navbar.Brand>
          <img
            src={logo}
            height={50}
            width={100}
            className="d-inline-block align-middle"
            alt="AccuPrecision"
          />{" "}
          Vendor Portal
        </Navbar.Brand>

        <Navbar.Collapse className="justify-content-end">
          {user !== undefined ? (
            <Navbar.Text>
              Hi, {user?.attributes?.given_name} {user?.attributes?.family_name}
              <br />
              <Button variant="link" onClick={() => Auth.signOut()}>
                Sign Out
              </Button>
            </Navbar.Text>
          ) : null}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
